import { CSSProperties } from "react";

export const ellipsis_text: CSSProperties = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};
